<template>
    <div class="json-editor" v-if="isInit">
        <el-form ref="form" :model="field" :label-width="field.name ? '120px' : '0'">
            <el-form-item
                class="input-row"
                :label="field.desc">
                <div v-if="field.name" slot="label" class="label-item common">
                    <p class="label-text">{{ field.desc }}</p>
                    <el-tooltip class="item" effect="light" placement="bottom-start">
                        <div slot="content">
                            - name: <strong>{{ field.name }}</strong><br/>
                        </div>
                        <i class="label-icon el-icon-info"></i>
                    </el-tooltip>
                </div>
                <div class="editor-block">
                    <el-alert
                        v-if="alertText"
                        :title="alertText"
                        type="warning">
                    </el-alert>
                    <codeEditor ref="codeEditorEle" :name="field.name" @init-ace-complete="codeEditorInitHandler" />
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from 'moment';
import codeEditor from '../codeEditor.vue';

export default {
    name: 'json-editor',
    props: ['field', 'autoInit'],
    data() {
        return {
            codeEditorEle: null,
            alertText: '',
            isInit: this.autoInit
        }
    },
    components: {
        codeEditor
    },
    watch: {
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['codeEditorEle'];
        },
        getResField() {
            let isJSON = true;
            const jsonRes = this.$refs['codeEditorEle'].getValue();
            try {
                JSON.parse(jsonRes);
            } catch(e) {
                isJSON = false;
                this.alertText = `json验证失败`;
                setTimeout(() => {
                    this.alertText = '';
                }, 5000);
            }
            if (!isJSON) {
                return;
            }
            this.field.def_val = jsonRes;
            return this.field;
        },
        codeEditorInitHandler() {
            this.codeEditorEle = this.$refs['codeEditorEle'];
            this.codeEditorEle.setValue(this.field.def_val);
        }
    },
    computed: {
    },
    mounted() {
    },
    beforeDestroy() {
        //销毁前先更新修改的值，如果格式错误则用原来的值
        let jsonRes = this.getResField();
        if(jsonRes){
            this.$emit('val-change',jsonRes.def_val);
        } 
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .json-editor {
        .label-item();
        .editor-block {
            height: 200px;
            position: relative;
            .el-alert--warning {
                position: absolute;
                top: 0;
                right: 0;
                width: 200px;
                height: 35px;
                z-index: 99;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/jsonEditor.vue